<template>
	<!-- 限免 -->
	<div class="xianmianBox">
		<div class="timeBox">
			<div class="timeLimit">
				<div>
					<img src="../../assets/img/xmabsLeft_icon.png" alt="" class="xsyficon01">
					<h4>限时免费</h4>
					<img src="../../assets/img/xsyficon02.png" alt="" class="xsyficon02">
				</div>
				<p class="xstime">
					<!-- <span>{{hh}}</span>:<span>{{mm}}</span>:<span>{{ss}}</span> -->
					<van-count-down :time="time">
					  <template #default="timeData">
					    <span class="block">{{ timeData.hours }}</span>
					    <span class="colon">:</span>
					    <span class="block">{{ timeData.minutes }}</span>
					    <span class="colon">:</span>
					    <span class="block">{{ timeData.seconds }}</span>
					  </template>
					</van-count-down>
					<img src="../../assets/img/xmAbs_icon.png" alt="" class="xsyficon03">
				</p>
			</div>
			<div class="btn_sc">
				<button @click='toCollect'>一键收藏订阅</button>
			</div>
		</div>
		<!-- 列表数据 -->
		<div>
			<div class="blockBox">
				<div class="blockLeft" v-for="(item,index) in xianList" :key="item.book_id">
					<div class="book_Img" @click="jumpBookinfo(item.book_id)">
						<img :src="$api.$BASE_URL_img + item.cover_image" alt="" />
					</div>
					<div class="blockBookInfo">
						<div class="bookName">{{item.name}}
							<p><span>{{item.total_words}}字</span><span class="wanjie" :class="item.state == '连载中' ? 'txtGreen' : ''">{{item.progress_status_name}}</span></p>
						</div>
						<div class="auther" @click="toZz(item.author_id)"><span>{{item.author}}</span>

						</div>
						<p class="bookType">{{item.original_name}}-{{item.appetency_name}}-{{item.epoch_name}}-{{item.type_name}}</span>
							<p class="introduction">{{item.introduce}}</span>
								<div class="book_button">
									<button v-for="i in item.lable_list" @click="keywordsFn(i.name)">{{i.name}}</button>
								</div>
					</div>
				</div>
			</div>
		</div>

		<!-- 往期限免 -->
		<div class="limiteBtn">
			<button @click="jumgpwqxm">往期限免<span class="arrRight">&gt;&gt;&gt;&gt;</span></button>
		</div>
		<!-- 书籍类型分化 -->
		<div class="bookTypeBox">
			<div class="bookTypeList">
				<p v-for="(item,index) in bookTypeList" :key="item.id" :class="bookTypeIndex == index ? 'active' : ''" @click="bookTypeFn(index,item.id)">
					<span>{{item.type}}</span>
					<span class="line" v-show="index == 4 || index == 9 ? false : true">|</span>
				</p>
			</div>
		<!-- 	<van-pull-refresh v-model="isLoading" @refresh="pullDown">
				<van-list v-model="loading" :finished="completed" finished-text="没有更多了" @load="pullup"> -->
					<div class="bookTypeInfo">
						<p v-for="item in sanList" @click="jumpBookinfo(item.id)">{{item.name}}</p>
					</div>
			<!-- 	</van-list>
			</van-pull-refresh> -->

		</div>
	</div>
</template>

<script>
	import {
		Toast
	} from 'vant';
	export default {
		data() {
			return {
				bookTypeIndex: 0,
				bookInfoList: [],
				xianList: [],
				bookTypeList: [{
					id: 30,
					type: "现言"
				}, {
					id: 29,
					type: "古言"
				}, {
					id: 31,
					type: "幻言"
				}, {
					id: 27,
					type: "古纯"
				}, {
					id: 33,
					type: "幻纯"
				}, {
					id: 28,
					type: "现纯"
				}, {
					id: 34,
					type: "百合"
				}, {
					id: 24,
					type: "衍言"
				}, {
					id: 25,
					type: "衍纯"
				}, {
					id: 18,
					type: "无CP"
				}],
				sanList: [], //三级分类
				loading: false, //控制加载数据
				completed: false, //是否加载完毕
				pageno: 1, //第几页
				pagesize: 20, //默认10条
				isLoading: false, //刷新
				finished: false, //全部数据
				loadingTip: "拼命加载中。。。。", //上拉提示
				Realname: '',
				thridFree: 30,
				book_ids: '', //所有书籍book_ids
				hh: '00',
				mm: '00',
				ss: '00',
				timeflag: false,
				isfail: false,
				time: 7.01 * 60 * 60 * 1000,
			}
		},
		created() {
			this.get_xianmian();
			this.get_thrid_free_list(this.thridFree)
		},
		mounted() {
			// var that = this;
			let time = setInterval(() => {
				if (this.timeflag == true) {
					clearInterval(time)
				}
				this.timeDown();
			}, 500)
		},
		methods: {
			timeDown() {
				const endTime = new Date(this.beginTime).getTime() + 24 * 60 * 60 * 1000;
				const nowTime = new Date(this.beginTime);
				var date = new Date();
				var now = date.getTime(nowTime);
				//设置截止时间
				var endDate = new Date(endTime);
				var end = endDate.getTime();
				//时间差
				var rightTime = end - now; //截止时间减去当前时间
				if (rightTime > 0) { //判断剩余倒计时时间如果大于0就执行倒计时否则就结束
					// var dd = Math.floor(rightTime / 1000 / 60 / 60 / 24);
					var hh = Math.floor((rightTime / 1000 / 60 / 60) % 24);
					var mm = Math.floor((rightTime / 1000 / 60) % 60);
					var ss = Math.floor((rightTime / 1000) % 60);
					this.hh = hh;
					this.mm = mm;
					this.ss = ss;
				} else {
					this.isfail = true;
				}
			},
			bookTypeFn(index, id) {
				// alert(index,'bookTypeFn')
				this.bookTypeIndex = index;
				this.$router.push({
					path: '/bookcity',
					query: {
						id: id
					}
				});
				console.log(this.$route.query.id, '0000')
				this.thridFree = this.$route.query.id;
				this.pageno = 1;
				this.get_thrid_free_list(this.thridFree)
			},
			jumgpwqxm() {
				this.$router.push({
					path: '/wangqixianmian',
					query: {
						getSecond_tab: 3,
						getFirstvalue_tab: 0,
						url: 'xianmian'
					}
				})
			},
			//作者专栏
			toZz(val) {
				this.$router.push({
					path: '/autherZl',
					query: {
						user_id: val
					}
				})
			},
			// 跳转详情页
			jumpBookinfo(val) {

				this.$router.push({
					path: '/bookinfo',
					query: {
						id: val,
						getSecond_tab: 3,
						getFirstvalue_tab: 0,
					}
				})
			},
			get_xianmian() {
				this.$axios.post(this.$api.xianmian_index).then(res => {
					console.log(res, '限免')
					if (res.status == 200) {
						this.xianList = res.data.data
						let book_ids = [];
						for (let i = 0; i < this.xianList.length; i++) {
							var id = this.xianList[i].book_id
							book_ids.push(id)
						}
						this.book_ids = book_ids.join(',')
						console.log(this.book_ids)
					}

				})
			},
			get_thrid_free_list(id) {
				this.thridFree = id;
				this.$axios.post(`${this.$api.thrid_free_list}`, {
					category_id: this.thridFree,
					// page: this.pageno,
					// limit: this.pagesize,
				}).then(res => {
					console.log(res, '三级分类')
					this.sanList = [];

					if (res.status == 200) {
						console.log(res.data.data, 'res.data.data.list-----------------------')
						if(res.data.data != undefined){
							this.sanList.push(...res.data.data);
							this.pageno++;
							this.loading = false;
							if (res.data.data.length == 0) {
								this.isLoading = false;
							} else if ((this.pageno * this.pagesize) > res.data.data.count) {
								this.completed = true;
							}
						}
						
					}

				})
			},
			//上滑加载
			pullup() {
				if (this.completed) {
					return
				}
				this.pageno++;
				console.log(this.pageno, 'pullup')
				this.get_thrid_free_list(this.thridFree)
			},
			pullDown() {
				// this.pageno = 1;
				this.pagesize = 20;
				this.completed = false;
				this.pageno = 1;
				this.isLoading = false;
				this.sanList = [];
				this.get_thrid_free_list(this.thridFree)
			},
			// infiniteScroll() {
			// 	this.pageno++;
			// 	this.get_thrid_free_list(this.thridFree)
			// },
			// 收藏
			toCollect() {
				let xmToken = JSON.parse(localStorage.getItem('userInfo')).token;
				this.$axios.post(`${this.$api.xianmian_collect}?books_ids=${this.book_ids}&token=${xmToken}`).then(res => {
					if (res.data.code == 1) {
						Toast('收藏成功');
					} else {
						Toast('收藏失败');
					}
				})

			},
			// 关键字
			keywordsFn(word) {
				console.log(word);
				this.$router.push({
					path: '/searchResult',
					query: {
						keywordHost: word,
						id: this.id,
						getSecond_tab: 3,
						getFirstvalue_tab: 0,
						url: 'xianmian'
					}
				})
			}
		}
	}
</script>

<style lang="less" scoped>
	.xianmianBox {
		background-color: #fff;
		padding-top: 60px;
		overflow-y: scroll;
		height: calc(100vh - 220px);
	}

	.timeBox {
		height: 80px;
		display: flex;
		background-color: #fff;
		// padding: 20px 0;

		.timeLimit {
			flex: 1;
			line-height: 80px;
			display: flex;

			div {
				flex: 1;
				position: relative;

				h4 {
					color: #ff4081;
					font-size: 32px;
					/*px*/
					padding-left: 16px;
					background-color: transparent;
				}

				.xsyficon01 {
					width: 120px;
					height: 50px;
					position: absolute;
					top: -10px;
					left: -16px;
				}

				.xsyficon02 {
					width: 50px;
					position: absolute;
					top: 5px;
					right: -10px;
					vertical-align: middle;
				}
			}

			.xstime {
				flex: 1;
				display: inline-block;
				margin-left: 5px;
				position: relative;
				padding-top: 14px;
				span {
					padding: 0 6px;
					color: #ff4081;
					font-size: 32px;
					/*px*/
				}

				.xsyficon03 {
					width: 50%;
					position: absolute;
					top: 10%;
					right: -90px;
				}
			}
		}

		.btn_sc {
			flex: 1;
			position: relative;

			button {
				position: absolute;
				top: 50%;
				right: 16px;
				transform: translateY(-50%);
				border: 0;
				background-color: #fff8fa;
				outline: none;
				border: 1px solid #fec6d5;
				/*no*/
				border-radius: 28px;
				padding: 0px 20px;
				line-height: 40px;
				color: #fa7298;
				font-size: 26px;
				/*px*/
			}
		}
	}

	//列表数据
	.blockBox {
		overflow: hidden;
		position: relative;
		padding: 0 16px;
		background-color: #fff;

		.blockLeft {
			display: flex;
			padding: 20px 0px;
			padding-bottom: 20px;
			border-bottom: 1px solid #f0f0f0;

			/*no*/
			.book_Img {
				// width: 138px;
				height: 240px;

				img {
					display: block;
					float: left;
					width: 155px;
					height: 220px;
					/*px*/
					-webkit-box-shadow: 0 3px 3px 0 rgba(0, 0, 0, .3);
					/*no*/
					-moz-box-shadow: 0 3px 3px 0 rgba(0, 0, 0, .3);
					/*no*/
					box-shadow: 0 3px 3px 0 rgba(0, 0, 0, .3);
					/*no*/
				}
			}

			.blockBookInfo {
				margin-left: 20px;
				flex: 1;
				font-size: 26px;
				/*px*/
				line-height: 30px;

				.auther {
					font-size: 28px;
					/*px*/
					color: #676767;
					position: relative;

					.btn_sc {
						flex: 1;

						button {
							position: absolute;
							top: 0px;
							right: 0px;
							border: 0;
							background-color: #fff8fa;
							outline: none;
							border: 1px solid #fec6d5;
							/*no*/
							border-radius: 28px;
							padding: 0px 20px;
							line-height: 40px;
							color: #fa7298;
							font-size: 26px;
							/*px*/
						}
					}
				}

				.bookName {
					// line-height: 40px;
					padding-bottom: 20px;
					font-size: 30px;
					/*px*/
					color: #000000;
					// font-weight: bold;

					p {
						display: inline-block;
						float: right;
						font-weight: 400;

						span {
							margin-left: 8px;
							color: #4c4c4c;
							font-size: 26px;
							/*px*/
						}

						// .wanjie {
						// 	color: #ff0000;
						// }

						// .txtGreen {
						// 	color: #5ca615;
						// }
					}
				}

				.auther {
					color: #000;
					opacity: 0.6;
					font-size: 26px;
					/*px*/
				}

				.bookType,
				.introduction {
					padding-top: 20px;
					color: #000;
					opacity: 0.4;
					font-size: 24px;
					/*px*/
				}

				.introduction {
					width: 60vw;
					padding-top: 15px;
					overflow: hidden;
					white-space: nowrap;
					text-overflow: ellipsis;
				}

				.book_button {
					margin-top: 15px;
					display: flex;
					align-items: center;

					button {
						border: 0;
						outline: none;
						border: 1px solid #fec6d5;
						/*no*/
						border-radius: 28px;
						padding: 0px 20px;
						display: inline-block;
						line-height: 36px;
						/*px*/
						background-color: #fff8fa;
						color: #fa7298;
						margin-right: 20px;
						font-size: 24px;
						/*px*/
						overflow: hidden;
						text-overflow: ellipsis;
						white-space: nowrap;
					}

					.active {
						background-color: #fa7298;
						color: #ffffff;
					}
				}
			}
		}

	}

	// 往期限免btn
	.limiteBtn {
		text-align: center;
		font-size: 32px;
		/*px*/
		padding: 20px 0;
		background-color: #fff;
		border-bottom: 5px solid #f0f0f0;

		/*no*/
		button {
			border: 0;
			// border: 1px solid #fec6d5;/*no*/
			border-radius: 30px;
			padding: 5px 20px;
			background-color: #fff;
			color: #ff70a0;

			.arrRight {
				padding-left: 25px;
				font-size: 30px;
				/*px*/
			}
		}
	}

	// 书籍类型分化
	.bookTypeBox {
		margin-top: 10px;
		padding: 0 16px;
		background-color: #fff;

		.bookTypeList {
			line-height: 60px;
			overflow: hidden;

			p {
				float: left;
				width: 100% / 5;
				font-size: 28px;
				/*px*/
				text-align: center;

				span {
					color: #ff4081;

				}

				.line {
					float: right;
					padding: 0 10px;
					color: #dbdbdb;
				}
			}

			p.active {
				font-weight: bold;
				transform: scale(1.1);
			}
		}

		.bookTypeInfo {
			background-color: #fff;
			overflow: hidden;

			p {
				width: calc(50% - 20px);
				// padding-left: 20px;
				float: left;
				line-height: 60px;
				font-size: 30px;
				/*px*/
				color: #000;
				height: 60px;
				overflow: hidden;
			}

			p:nth-child(2n) {
				padding-left: 30px;
			}
		}
	}
</style>
